/* ==========================================================================
   page.js — content page interactions
   - TOC active-link highlighting as you scroll through sections
   - Smooth scroll to section anchors (native CSS handles this now)
   ========================================================================== */

(() => {
  'use strict';

  const tocLinks = document.querySelectorAll('[data-toc-link]');
  if (!tocLinks.length) return;

  const sections = Array.from(tocLinks)
    .map((link) => document.querySelector(link.getAttribute('href')))
    .filter(Boolean);

  if (!sections.length) return;

  // Set active TOC link based on which section is intersecting the viewport.
  // threshold + rootMargin: trigger when a section crosses the 30% mark from the top.
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const id = entry.target.id;
        tocLinks.forEach((link) => {
          link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
        });
      });
    },
    {
      rootMargin: '-30% 0px -60% 0px',
      threshold: 0,
    }
  );

  sections.forEach((section) => io.observe(section));
})();
